import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Repo from "../Repo/Repo";
import "./Category.scss";

interface CategoryProps {
  isInitializedAsOpen: boolean;
  title: string;
  type: "repo" | "text";
  repoList?: Array<any>;
  textList?: Array<any>;
  openFile: (file: any) => void;
  hidden: boolean;
}
const containerVariants = {
  hidden: { opacity: 0, height: 0 },
  visible: {
    opacity: 1,
    height: "auto",
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: { opacity: 1, x: 0 },
};

const Category: React.FC<CategoryProps> = ({
  isInitializedAsOpen,
  title,
  type,
  repoList,
  textList,
  openFile,
  hidden,
}) => {
  const [open, setOpen] = useState(isInitializedAsOpen);
  return (
    <div className="category-box" style={hidden ? { display: "none" } : {}}>
      <div className="category-box__title" onClick={() => setOpen(!open)}>
        {open ? (
          <svg
            style={{ marginLeft: "17px" }}
            width="9"
            height="7"
            viewBox="0 0 9 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.74998 6.65186L0.499969 0.651856L9 0.651855L4.74998 6.65186Z"
              fill="white"
            />
          </svg>
        ) : (
          <svg
            width="6"
            height="9"
            viewBox="0 0 6 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 4.37245L-3.71548e-07 8.62247L0 0.122436L6 4.37245Z"
              fill="white"
            />
          </svg>
        )}
        {title}
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            className="category-box__content"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={containerVariants}
            style={{ overflow: 'hidden' }}
          >
            {type === "repo"
              ? repoList?.map((repo) => (
                  <motion.div key={repo.id} variants={itemVariants}>
                    <Repo
                      title={repo.title}
                      isInitializedAsOpen={repo.open}
                      iconColor={repo.folderColor}
                      files={repo.files}
                      openFile={(e) => openFile(e)}
                    />
                  </motion.div>
                ))
              : textList?.map((item, idx) => (
                  <motion.div
                    key={idx}
                    variants={itemVariants}
                    className="category-box__content__text-type-item"
                    onClick={() => openFile(item)}
                    whileHover={{ x: 5 }}
                  >
                    {item.icon}
                    {item.label}
                  </motion.div>
                ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
export default Category;
